import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserPurchasesOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

export function useEnduserPurchases(options: UseEnduserPurchasesOptions = {}) {
  const { limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "purchases",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allPurchases = query.data ?? [];

  // Sort by most recent first (using processedAt or updatedAt as fallback)
  const sortedPurchases = [...allPurchases].sort((a, b) => {
    const aTime = a.processedAt ? new Date(a.processedAt).getTime() : new Date(a.updatedAt).getTime();
    const bTime = b.processedAt ? new Date(b.processedAt).getTime() : new Date(b.updatedAt).getTime();
    return bTime - aTime;
  });

  return {
    ...query,
    purchases: sortedPurchases,
  };
}
